<div
	class="mat-dialog-title-base flex flex-col"
	matDialogTitle
>
	<h4 class="my-0">{{ 'comego.absenceConflictDialog.title' | translate }}</h4>
</div>
<mat-dialog-content class="!max-h-[550px] !overflow-y-auto">
	<p class="mb-4">{{ 'comego.absenceConflictDialog.message' | translate }}</p>
	<ul class="flex flex-col gap-3 list-none p-0 m-0">
		@for (row of conflictRows; track row.userId) {
		<li class="flex flex-col gap-1">
			<div class="flex items-center gap-2">
				<app-user-avatar
					[userId]="row.userId"
					class="rounded-full shrink-0"
					size="32px"
				></app-user-avatar>
				<span class="font-medium">{{ row.name }}</span>
			</div>
			<mat-accordion
				class="ml-10 flex flex-col gap-0.5"
				multi
			>
				@for (dateGroup of row.dateGroups; track dateGroup.date.getTime()) {
				<mat-expansion-panel
					[expanded]="conflictRows.length === 1 && row.dateGroups.length === 1"
					class="mat-elevation-z0 rounded-lg mb-1 panel"
				>
					<mat-expansion-panel-header>
						<mat-panel-title>{{ dateGroup.date | date: 'dd.MM.yyyy' }}</mat-panel-title>
					</mat-expansion-panel-header>
					<ul class="flex flex-col gap-2 list-none p-0 m-0">
						<div class="flex items-center justify-between mb-1">
							<h3 class="text-muted mat-typography mt-3">{{ 'comego.existingEntries' | translate }}</h3>
							<div class="flex items-center gap-1">
								<button
									(click)="$event.stopPropagation(); openUpdateMultiDialog(dateGroup.date , row.userId)"
									[matTooltip]="'utils.edit' | translate"
									*ngIf="canUpdateTimes$ | async"
									class="!h-6 !w-6 !flex !items-center !justify-center"
									mat-icon-button
									type="button"
								>
									<mat-icon class="!leading-none">edit</mat-icon>
								</button>
								<button
									(click)="$event.stopPropagation(); deleteExistingEntries(dateGroup.date , row.userId)"
									[matTooltip]="'utils.deleteAllEntries' | translate"
									*ngIf="canUpdateTimes$ | async"
									class="!h-6 !w-6 !flex !items-center !justify-center"
									mat-icon-button
									type="button"
								>
									<mat-icon class="!leading-none">delete</mat-icon>
								</button>
							</div>
						</div>
						@for (entry of dateGroup.entries; track entry.id) {
						<li
							class="flex items-center justify-between p-2 bg-neutral-50 dark:bg-neutral-800 rounded border border-neutral-200 dark:border-neutral-700"
						>
							<div class="flex items-center space-x-2">
								<div
									[ngClass]="
										entry.type === 'work'
											? 'border border-green-400 bg-green-600/90 dark:bg-green-600/60 text-green-200'
											: entry.type === 'absence'
												? 'border border-violet-400 bg-violet-800/90 dark:bg-violet-800/60 text-violet-100'
												: 'dark:bg-neutral-600 bg-neutral-600/80'
									"
									class="flex size-6 flex-shrink-0 items-center justify-center rounded-full text-neutral-100"
								>
									<mat-icon
										class="text-center mt-1"
										inline
									>
										{{ iconMap[entry.type] ?? 'schedule' }}
									</mat-icon>
								</div>

								<div class="flex flex-col leading-tight">
									<div class="flex items-center space-x-1.5">
										<div class="text-xs font-medium">
											<span>{{ entry.start | formatDate: 'time' }}</span>
											<span>-</span>
											@if (entry.end) {
											<span>{{ entry.end | formatDate: 'time' }}</span>
											} @else {
											<span class="text-warn animate-pulse font-medium">
												{{ 'time.recording' | translate }}
											</span>
											}
										</div>
										@if (entry.end) {
										<span class="text-xs text-muted opacity-70">
											({{ calculateExistingEntryDuration(entry) | parseMsAsDuration: false }})
										</span>
										}
									</div>
								</div>
							</div>
						</li>
						}
					</ul>
				</mat-expansion-panel>
				}
			</mat-accordion>
		</li>
		}
	</ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
	@if(canUpdateTimes$ | async) {
	<button
		[matDialogClose]="'overwrite'"
		color="primary"
		mat-raised-button
	>
		{{ 'utils.overwrite' | translate }}
	</button>
	} @if(!hideSkip.value) {
	<button
		[matDialogClose]="'skip'"
		mat-stroked-button
	>
		{{ 'comego.absenceConflictDialog.skip' | translate }}
	</button>
	}
	<button
		[matDialogClose]="'cancel'"
		mat-stroked-button
	>
		{{ 'utils.cancel' | translate }}
	</button>
</mat-dialog-actions>
